import { render, staticRenderFns } from "./negConsList.vue?vue&type=template&id=d71231dc"
import script from "./negConsList.vue?vue&type=script&lang=js"
export * from "./negConsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports